import AxiosConfig from './serverAxiosConfig'
import firebase from '../config/FirebaseConfig'

const getServicesAndIndustries = async () => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get('/agency/services-and-industries', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const getCountries = async () => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get('/agency/countries', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data.countries.sort((a, b) => a.name.localeCompare(b.name))
}

const submitAgencyListing = async (agencyListing) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post('/agency/submit-agency-listing', agencyListing, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  // Return the firebase id of the listing
  return data.id
}

// Update an existing agency listing
const updateAgencyListing = async (agencyListing) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post('/agency/update-agency-listing', agencyListing, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  // Return the firebase id of the listing
  return data.id
}

const generateAgencyListing = async (agencyWebsiteUrl, linkedInUrl) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/agency/generate-agency-listing',
    {
      agencyWebsite: agencyWebsiteUrl,
      agencyLinkedInProfile: linkedInUrl
    },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const uploadAgencyAvatar = async (file) => {
  const { Aa: token } = firebase.auth().currentUser

  const formData = new FormData()
  formData.append('avatar', file)

  const { data } = await AxiosConfig.post('/agency/upload-agency-avatar', formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    }
  })

  return data.avatarUrl
}

export default {
  generateAgencyListing,
  getServicesAndIndustries,
  getCountries,
  uploadAgencyAvatar,
  submitAgencyListing,
  updateAgencyListing
}